<template>
  <layout-default :hide-footer-mobile="true" :show-alternative-header="true">
    <steps-header-recomend :current-step="1"></steps-header-recomend>

    <div class="recomendador1">
      <div class="pdv-container">
        <div class="recomendador1-parent">
          <div class="columna-contenido">
            <h2>El 2025 soy estudiante de:</h2>
            <div class="content-cards-programs">
                <div
                class="cards-programs"
                :class="{ 'border-card': selectedProgram == '1' }"
                @click="changeSelected('1')"
              >
                <div class="cards-programs-info">
                  <img
                    src="/images/featured/icon-primero.svg"
                    class=""
                    alt="icon-primero"
                  />
                  <p>1° Medio</p>
                </div>
                <div class="cards-programs-input">
                  <input
                    type="radio"
                    name="programa"
                    value="1"
                    v-model="selectedProgram"
                    @change="choseOption($event)"
                  />
                </div>
              </div> 
              <div
                class="cards-programs"
                :class="{ 'border-card': selectedProgram == '2' }"
                @click="changeSelected('2')"
              >
                <div class="cards-programs-info">
                  <img
                    src="/images/featured/icon-segundo.svg"
                    class=""
                    alt="icon-segundo"
                  />
                  <p>2° Medio</p>
                </div>
                <div class="cards-programs-input">
                  <input
                    type="radio"
                    name="programa"
                    value="2"
                    v-model="selectedProgram"
                    @change="choseOption($event)"
                  />
                </div>
              </div> 
              <div
                class="cards-programs"
                :class="{ 'border-card': selectedProgram == '3' }"
                @click="changeSelected('3')"
              >
                <div class="cards-programs-info">
                  <img
                    src="/images/featured/icon-tercero.svg"
                    class=""
                    alt="icon-tercero"
                  />
                  <p>3° Medio</p>
                </div>
                <div class="cards-programs-input">
                  <input
                    type="radio"
                    name="programa"
                    value="3"
                    v-model="selectedProgram"
                  />
                </div>
              </div> 
              <div
                class="cards-programs"
                :class="{ 'border-card': selectedProgram == '4' }"
                @click="changeSelected('4')"
              >
                <div class="cards-programs-info">
                  <img
                    src="/images/featured/icon-cuarto.svg"
                    class=""
                    alt="icon-cuarto"
                  />
                  <p>4° Medio</p>
                </div>
                <div class="cards-programs-input">
                  <input
                    type="radio"
                    name="programa"
                    value="4"
                    v-model="selectedProgram"
                    @change="choseOption($event)"
                  />
                </div>
              </div>
              <div
                class="cards-programs"
                :class="{ 'border-card': selectedProgram == 'e' }"
                @click="changeSelected('e')"
              >
                <div class="cards-programs-info">
                  <img
                    src="/images/featured/icon-egresado.svg"
                    class=""
                    alt="icon-egresado"
                  />
                  <p>Egresado</p>
                </div>
                <div class="cards-programs-input">
                  <input
                    type="radio"
                    name="programa"
                    value="e"
                    v-model="selectedProgram"
                    @change="choseOption($event)"
                  />
                </div>
              </div>

              <div class="flex mb-4">
                <Button
                  :disabled="selectedProgram == ''"
                  title="Continuar"
                  type="primario"
                  size="medium"
                  @onClick="goToNextStep()"
                />
              </div>
            </div>
          </div>
          <div class="columna-ilustracion">
            <img
              src="/images/featured/boys-books-computers-group.svg"
              class=""
              alt="boys-books-computers-group"
            />
          </div>
        </div>
      </div>

      <div class="info-recomendador1">
        <img
          src="/images/featured/tri-sup-izq-gris-mobile.svg"
          class="only-mobile w-full"
          alt="tri-sup-izq-gris-mobile"
        />
        <img
          src="/images/featured/tri-sup-izq-gris-desktop.svg"
          class="only-desktop w-full"
          alt="tri-sup-izq-gris-desktop"
        />
        <div class="fondo">
          <div class="pdv-container">
            <div class="perent-columns">
              <div class="column-info">
                <h2 class="titulo">Si quieres saber más</h2>
                <div class="links">
                  <a
                    href="/documents/fichas-academicas.pdf"
                    target="_blank"
                    class="links-items"
                  >
                    <div class="links-items-text">
                      <img
                        src="/images/featured/link.svg"
                        class=""
                        alt="link"
                      />
                      <span>Conoce todos los programas</span>
                    </div>
                    <img
                      src="/images/featured/arrow-right.svg"
                      class=""
                      alt="arrow-right"
                    />
                  </a>

                  <a
                    href="/documents/fichas-academicas.pdf"
                    target="_blank"
                    class="links-items"
                  >
                    <div class="links-items-text">
                      <img
                        src="/images/featured/link.svg"
                        class=""
                        alt="link"
                      />
                      <span>Modelo Educativo Preu PDV 360°</span>
                    </div>
                    <img
                      src="/images/featured/arrow-right.svg"
                      class=""
                      alt="arrow-right"
                    />
                  </a>
                </div>

                <h3 class="texto only-desktop">
                  ¿Tienes dudas sobre nuestros programas? Hablemos
                </h3>
                <div class="botones only-desktop">
                  <a
                    href="tel:6005002020"
                    class="boton-new-primario boton-new-mediano"
                  >
                    <img
                      src="/images/featured/call-icon.svg"
                      class=""
                      alt="callicon"
                    />
                    +56 2 2994 9850
                  </a>
                  <a
                    href="https://www.preupdv.cl/ayuda"
                    target="_blank"
                    class="boton-new-terciario boton-new-mediano"
                  >
                    Preguntas frecuentes
                  </a>
                  <a
                    href="https://www.preupdv.cl/contacto"
                    target="_blank"
                    class="boton-new-terciario boton-new-mediano"
                  >
                    Formulario de contacto
                  </a>
                </div>
              </div>
              <div class="column-ilustracion">
                <img
                  src="/images/featured/boy-computer-list-cap-design-verde.svg"
                  class="w-full"
                  alt="boy-bored-computer-coffee"
                />
              </div>

              <div class="only-mobile column-info">
  <h3 class="texto">
    ¿Tienes dudas sobre nuestros programas? Hablemos
  </h3>
  <div class="botones">
    <!-- Enlace para llamar -->
    <a
      href="tel:+56229949850" 
      class="boton-new-primario boton-new-mediano"
    >
      <img
        src="/images/featured/call-icon.svg"
        class=""
        alt="callicon"
      />
      +56 2 2994 9850
    </a>
    
    <!-- Botón de preguntas frecuentes -->
    <Button
      title="Preguntas frecuentes"
      type="terciario"
      size="medium"
      :fullWidth="true"
    />
  </div>
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loading" />
  </layout-default>
</template>

<script>
import LayoutDefault from "@/layouts/Default";
import StepsHeaderRecomend from "@/components/StepsHeaderRecomend";
import Loader from "@/components/Loader";
import Button from "@/components/featured/Button";

export default {
  components: {
    LayoutDefault,
    StepsHeaderRecomend,
    Loader,
    Button,
  },
  data() {
    return {
      loading: false,
      selectedProgram: "",
    };
  },
  methods: {
    async goToNextStep() {
      this.loading = true;
      const { data } = await this.Axios.get(
        `/programs-without-childrens?year=${this.selectedProgram}&defaults=true`
      );
      await this.$store.dispatch("setProgramData", data);
      this.$store.dispatch("setFormatProgramName", {
        nivel1: this.getProgram(),
        nivel2: "",
        nivel3: "",
      });
      this.$router.push({
        name: "Re-Step2",
        params: { course: this.selectedProgram },
      });
    },
    changeSelected(option) {
      this.selectedProgram = option;
      //this.goToNextStep(option)
    },
    choseOption($event) {
      this.selectedProgram = $event.target.value;
    },
    getProgram() {
      switch (this.selectedProgram) {
        case "1":
          return "1° Medio";
        case "2":
          return "2° Medio";
        case "3":
          return "3° Medio";
        case "4":
          return "4° Medio";
        case "e":
          return "Egresado";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 24px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.recomendador1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding-top: 32px;
  }
  @media (min-width: 769px) {
    padding-top: 40px;
  }
}
.recomendador1-parent {
  display: flex;
  @media (max-width: 768px) {
    margin: 0 24px;
    flex-direction: column;
  }
  @media (min-width: 769px) {
    margin: 0 76px;
    flex-direction: row;
  }
  .columna-contenido {
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: 63%;
    }
    h2 {
      color: $neutralBlack;
      @media (max-width: 768px) {
        font-family: "Poppins-Medium", sans-serif;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 32px;
      }
      @media (min-width: 769px) {
        font-family: "Poppins-Bold", sans-serif;
        font-size: 32px;
        line-height: 42px;
        margin-bottom: 40px;
      }
    }

    .content-cards-programs {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .cards-programs {
        background: $neutral05;
        border: solid 2px $colorTerciarioSuave;
        height: 72px;
        border-radius: 8px 24px 8px 8px;
        padding: 12px 16px;
        display: flex;
        justify-content: space-between;

        @media (max-width: 768px) {
          width: 100%;
        }
        @media (min-width: 769px) {
          width: 400px;
        }

        .cards-programs-info {
          display: flex;
          align-items: center;
          height: 100%;
          gap: 12px;

          p {
            margin-bottom: 0;
            color: $neutralBlack;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 16px;
            line-height: 24px;
          }
        }
        .cards-programs-input {
          display: flex;
          align-items: center;
          height: 100%;
        }

        input[type="radio"] {
          appearance: none;
          background-color: $neutral05;
          margin: 0;
          font: inherit;
          color: currentColor;
          width: 1.25em;
          height: 1.25em;
          border: 0.15em solid currentColor;
          border-radius: 50%;
          transform: translateY(-0.075em);
          display: grid;
          place-content: center;
        }

        input[type="radio"]::before {
          content: "";
          width: 0.65em;
          height: 0.65em;
          border-radius: 50%;
          transform: scale(0);
          transition: 120ms transform ease-in-out;
          box-shadow: inset 1em 1em $morado50;
        }

        input[type="radio"]:checked::before {
          transform: scale(1);
        }

        input[type="radio"]:focus {
          border: 0.15em solid $morado50;
        }
      }
      .border-card {
        border: solid 2px $morado50 !important;
      }
    }
  }
  .columna-ilustracion {
    @media (max-width: 768px) {
      width: 100%;
      display: none;
    }
    @media (min-width: 769px) {
      width: 37%;
      padding-left: 63px;
    }
  }
}

.info-recomendador1 {
  .fondo {
    background-color: $neutral05;
  }

  .perent-columns {
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
      padding: 48px 24px;
    }
    @media (min-width: 769px) {
      flex-direction: row;
      padding: 40px 76px 64px 76px;
      gap: 50px;
    }

    .column-info {
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
      }
      @media (min-width: 769px) {
        width: 622px;
      }

      .titulo {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 40px;
          line-height: 50px;
          margin-bottom: 24px;
        }
      }
      .links {
        display: flex;
        flex-direction: column;
        @media (min-width: 769px) {
          margin-bottom: 40px;
        }

        .links-items {
          display: flex;
          justify-content: space-between;
          padding: 16px 0;

          @media (max-width: 768px) {
            width: 100%;
          }
          @media (min-width: 769px) {
            width: 400px;
          }

          .links-items-text {
            img {
              margin-right: 12px;
            }
            span {
              color: $neutralBlack;
              font-family: "Poppins-Medium", sans-serif;
              font-size: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .texto {
        color: $neutralBlack;
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 27px;
          line-height: 37px;
          margin-bottom: 32px;
        }
        @media (min-width: 769px) {
          font-family: "Poppins-Bold", sans-serif;
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }
      .botones {
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          flex-direction: column;
          gap: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: row;
          gap: 16px;
        }
      }
    }
    .column-ilustracion {
      @media (max-width: 768px) {
        width: 100%;
        margin: 48px 0 36px 0;
      }
      @media (min-width: 769px) {
        flex: 1;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.step-1-content {
  padding: 52px 0 100px 0;
  @include media-breakpoint-down(sm) {
    padding: 30px 0 0;
  }
  .question-form {
    font-size: 34px;
    line-height: 41px;
    margin-bottom: 30px;
    @include Gotham;
    color: #000;
    @include media-breakpoint-down(sm) {
      font-size: 25px;
      margin-bottom: 23px;
    }
  }
  .pdvxImg {
    width: 100%;
    border-radius: 20px;
  }
  .custom-list {
    @include media-breakpoint-up(sm) {
      margin-left: -15px;
    }
    li {
      p {
        line-height: 16px;
        font-size: 14px;
        @include alternative-light-regular;
        position: relative;
        padding-left: 18px;
        color: $gray-dark;
        margin-bottom: 0;
        &:before {
          content: "";
          width: 6px;
          height: 6px;
          background: $gray-light;
          border-radius: 50%;
          position: absolute;
          left: 2px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  .pdv-form-group {
    input[type="text"] {
      border: 1.2px solid #000000;
    }
    label {
      display: block;
      &.checkbox-label {
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }
    .location-container {
      padding-top: 3px;
    }
  }

  .address-item {
    ul {
      padding-left: 0;
      li {
        list-style: none;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        p {
          font-size: 16px;
          line-height: 22px;
          @include alternative-light-regular;
          margin-bottom: 0;
        }
        span {
          width: 20px;
          height: 20px;
          display: inline-flex;
          justify-content: center;
          margin-right: 5px;
          img {
            height: 20px;
          }
        }
      }
    }
  }

  .academic-programs {
    height: 50px;
    label {
      .check-box-text {
        display: flex;
        align-items: center;
        img {
          width: 31px;
          margin-right: 5px;
          &.help {
            width: 24px;
            margin-left: 5px;
          }
        }
        p {
          margin-bottom: 0;
          @include alternative-light-regular;
        }
        span {
          font-size: 13px;
          @include alternative-light-regular;
          padding: 0 5px;
          color: #fff;
          margin-left: 3px;
        }
      }
    }
    &:hover .labelWarning {
      visibility: visible;
    }
    .labelWarning {
      color: red;
      visibility: hidden;
      font-size: 10px;
    }
  }

  .map-container {
    height: 100%;
    iframe {
      @include media-breakpoint-down(sm) {
        height: 300px;
      }
    }
  }

  .custom-checkbox-cont {
    @include media-breakpoint-down(sm) {
      margin-bottom: 20px;
    }
  }
}

.pdv-submit-button {
  .form-group {
    margin-bottom: 0;

    .link-error-activator {
      display: inline-block;
    }
  }
  @include media-breakpoint-down(sm) {
    position: fixed;
    width: 100%;
    padding: 23px 16px;
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
    bottom: 0;
    left: 0;
    z-index: 99;
    background: #fff;
  }
}

.custom-search-input {
  width: 100%;
  ::placeholder {
    color: lightgray;
  }
}

.box-error-activator {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.element-disabled {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.disabled-courses-message {
  background: rgba(255, 237, 192, 0.41);
  display: flex;
  align-items: flex-start;
  padding: 14px;
  img {
    margin-right: 10px;
    margin-top: 5px;
    width: 18px;
  }
  p {
    font-size: 14px;
    line-height: 22px;
    @include alternative-light-regular;
    margin-bottom: 0;
  }
  ul {
    margin-bottom: 14px;
    padding-left: 15px;
    li {
      font-size: 14px;
      line-height: 22px;
      @include alternative-light-regular;
    }
  }
}
.buttons-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  overflow: hidden;

  .selectable-button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    // width: 350px;
    height: 130px;
    border-radius: 10px;
    // margin: 0 15px;
    padding: 0 20px;
    width: 197px;
    @include media-breakpoint-down(sm) {
      width: 100%;
      height: 104px;
      margin-bottom: 15px;
    }
    span {
      color: #fff;
    }
    .course-level {
      font-size: 45px;
      color: $yellow;
      font-weight: bold;
      margin-right: 15px;
      @include Gotham-Black;
    }
  }
}
.left-side-link {
  color: #000;
  text-decoration: underline;
  @include alternative-regular;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.07px;
  text-align: left;
  display: flex;
  align-items: center;
  img {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  &:hover {
    color: #000;
  }
}
.talk-section {
  background: #fdf4e1;
  padding-left: 60px;
  height: 120px;
  flex: 0 0 800px;
  @include media-breakpoint-down(sm) {
    padding-left: 0;
    height: 230px;
    margin-top: 15px;
    flex: 0 0 100%;
  }
  .img-element {
    @include media-breakpoint-down(sm) {
      order: 3;
      margin-left: 30px;
    }
    @media screen and (max-width: 430px) {
      width: 100%;
    }
  }
  .talk-button {
    @include media-breakpoint-down(sm) {
      margin-top: 20px;
      // margin-left: 15px;
      order: 2;
      padding-left: 30px;
    }
  }
}
.questions {
  @include alternative-medium-regular;
  @include media-breakpoint-down(sm) {
    margin-bottom: 10px;
  }
}
.course-name {
  @include alternative-regular;
  font-size: 20px;
  letter-spacing: -0.28px;
  line-height: 19px;
  @include media-breakpoint-down(sm) {
    font-size: 20px;
    letter-spacing: -0.28px;
    line-height: 19px;
  }
}
.button-inner-container {
  flex: 0 0 197px;
  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
    padding: 0;
  }
}
.questions-left-container {
  height: 130px;
  // flex: 0 0 247px;
  margin-right: 88px;
  @include media-breakpoint-down(sm) {
    margin-right: 0;
    margin-bottom: 30px;
  }
}
.link-container {
  margin-bottom: 16px;
}
.column-title {
  margin-bottom: 18px;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.24px;
  line-height: 22px;
}
.btn-outlined-black-step-one {
  background: transparent;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  @include Gotham-Light;
  padding: 6.14px 43px 9.86px 43px;
  width: 150px;
  position: relative;
  border: 1px solid #000;
  border-radius: 2px;
  z-index: 0;
  font-size: 15px;
  letter-spacing: -0.19px;
  line-height: 21px;
  text-align: center;
  margin-top: 12px;
  &:hover {
    color: #000;
    background: transparent;
  }
  &:active {
    background: transparent;
  }
  -webkit-appearance: unset;
  @include media-breakpoint-down(sm) {
    width: 172px;
    text-align: center;
  }
}
.questions-talk-section {
  @include alternative-medium-regular;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.24px;
  line-height: 22px;
}
.text-question {
  margin: 0;
  font-family: "ubuntu_mediumregular", Arial, sans-serif;
  span {
    margin: 0;
    font-family: "ubuntu_mediumregular", Arial, sans-serif;
    color: #000000;
    font-weight: bold;
    font-size: 17px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1270px;
  }
}
.main-talk-section-container {
  width: 1109px;
  @include media-breakpoint-down(sm) {
    width: 100%;
    margin-top: 6px !important;
  }
}
.buttons-selectable-container {
  margin-bottom: 55px;
}
@include media-breakpoint-down(sm) {
  .row {
    margin: 0;
  }
}
</style>
